import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import ItineraryBuilder from "@/pages/ItineraryBuilder";
import Experiences from "@/pages/Experiences";
import Providers from "@/pages/Providers";
import Hotels from "@/pages/Hotels";
import AITrainer from "@/pages/AITrainer";
import AIGenerate from "@/pages/AIGenerate";
import AdminUsers from "@/pages/AdminUsers";
import Backups from "@/pages/Backups";
import MarketingIntegrations from "@/pages/MarketingIntegrations";
import KimKimLeads from "@/pages/KimKimLeads";
import KimKimLeadDetail from "@/pages/KimKimLeadDetail";
import PublicPayment from "@/pages/PublicPayment";
import PublicExtraPayment from "@/pages/PublicExtraPayment";
import PublicCuratedPayment from "@/pages/PublicCuratedPayment";
import TripView from "@/pages/TripView";
import CuratedTripsList from "@/pages/CuratedTripsList";
import CuratedStatsDashboard from "@/pages/CuratedStatsDashboard";
import Partners from "@/pages/Partners";
import CuratedTripBuilder from "@/pages/CuratedTripBuilder";
import "@/App.css";

function HashRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/pay/extra/:token" element={<PublicExtraPayment />} />
      <Route path="/pay/curated/:token" element={<PublicCuratedPayment />} />
      <Route path="/pay/:token" element={<PublicPayment />} />
      <Route path="/trip/:token" element={<TripView />} />
      <Route path="/curated/:token" element={<TripView curatedMode />} />
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/itineraries/:id" element={<ItineraryBuilder />} />
        <Route path="/curated-trips" element={<CuratedTripsList />} />
        <Route path="/curated-trips/stats" element={<ProtectedRoute adminOnly><CuratedStatsDashboard /></ProtectedRoute>} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/sources" element={<Navigate to="/partners" replace />} />
        <Route path="/curated-trips/:id" element={<CuratedTripBuilder />} />
        <Route path="/experiences" element={<Experiences />} />
        <Route path="/providers" element={<Providers />} />
        <Route path="/hotels" element={<Hotels />} />
        <Route path="/ai/trainer" element={<AITrainer />} />
        <Route path="/ai/generate" element={<AIGenerate />} />
        <Route path="/admin/users" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
        <Route path="/admin/backups" element={<ProtectedRoute adminOnly><Backups /></ProtectedRoute>} />
        <Route path="/admin/marketing" element={<ProtectedRoute adminOnly><MarketingIntegrations /></ProtectedRoute>} />
        <Route path="/admin/kimkim-leads" element={<ProtectedRoute managerOnly><KimKimLeads /></ProtectedRoute>} />
        <Route path="/admin/kimkim-leads/:leadId" element={<ProtectedRoute managerOnly><KimKimLeadDetail /></ProtectedRoute>} />
      </Route>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <HashRouter />
          <Toaster position="bottom-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
